<template>
  <div class='service-provider-company-profile'>
    <avatar-upload  class="avatar" :file-url="fileUrl"  @changed='updateAvatarUrl'/>
    <div class='form'>
      <edit-service-provider-company-profile-form class='profile-form'/>
      <div class="actions d-flex">
        <v-btn color="primary" class='submit-form' @click="submit">
          {{ $t('save') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { UPDATE_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS } from '@/store/user/actionTypes';
import EditServiceProviderCompanyProfileForm from '@/components/forms/EditServiceProviderCompanyProfileForm.vue';
import AvatarUpload from '@/components/common/AvatarUpload.vue';

export default {
  name: 'ServiceProviderCompanyProfile',
  data() {
    return {
    };
  },
  components: {
    EditServiceProviderCompanyProfileForm,
    AvatarUpload,
  },
  computed: {
    ...mapGetters(['serviceProviderCompanyProfileDetails']),
    fileUrl() {
      if (!this.serviceProviderCompanyProfileDetails?.logoURL || this.serviceProviderCompanyProfileDetails?.logoURL?.startsWith('data')) {
        return this.serviceProviderCompanyProfileDetails?.logoURL;
      }
      return `${this.serviceProviderCompanyProfileDetails?.logoURL}?${Date.now().toString()}` || null;
    },
  },
  methods: {
    updateAvatarUrl(file) {
      this.serviceProviderCompanyProfileDetails.logoURL = file;
    },
    async submit() {
      await this.$store.dispatch(UPDATE_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS, this.serviceProviderCompanyProfileDetails);
    },
  },
};
</script>

<style lang='scss'>
@import '../../assets/styles/variables';
.service-provider-company-profile {
  display: flex;
  flex: 1;

  padding-top: 40px;
  padding-bottom: 40px;
  margin-left: 10%;

  padding-right: 152px;

  border-radius: 4px;
  background-color: $default-background-color;
}

.form {
  flex: 1;
  display: flex;
  flex-direction: column;
  .profile-form {
    flex: 1;
    max-width: 63%;
  }
}

.avatar {
  flex: 0.35;
  margin-right: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
